import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { CreateProjectRequest, GetAllClientsNames } from './../../../model/management-config/projectManagement';
import { NotificationService } from 'src/app/service/notification.service';
import { ProjectManagementService } from 'src/app/service/projectManagement.service';
import { User } from 'src/app/model/user';
import {Tests} from "../../../model/tests/tests";
import {TestsComponent} from "../../tests/tests.component";
import {TestsService} from "../../../service/tests.service";

@Component({
  selector: 'app-add-project',
  templateUrl: './add-project.component.html',
  styleUrls: ['./add-project.component.scss']
})
export class AddProjectComponent implements OnInit {

  @ViewChild(TestsComponent) testsComponent: TestsComponent;

  _projectForm: FormGroup;
  project: CreateProjectRequest = new CreateProjectRequest();
  minStartDate = new Date();
  minEndDate = new Date();

  clients: GetAllClientsNames[];
  selectedClient: string;
  updatedBy: string;
  profile: User = new User;
  email: string;
  tests: Tests;

  constructor(
    private projectService: ProjectManagementService,
    private _formBuilder: FormBuilder,
    private _notificationService: NotificationService,
    private _localStorage: LocalStorageService,
    private testsService: TestsService,
    public dialogRef: MatDialogRef<AddProjectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateProjectRequest) { }

  ngOnInit(){
    this.getClients();
      this._projectForm = this._formBuilder.group({
        // clientName: new FormControl({ value: this.data.clientId, disabled: false }),
      clientId: new FormControl({ value: this.data.clientId, disabled: false }),
      projectName: new FormControl(this.project.projectName),
      assessmentType: new FormControl({ value: this.project.assessmentType, disabled: false }),
      maxCallLimit: new FormControl({ value: this.project.maxCallLimit, disabled: false }),
      projectStartDate: new FormControl(this.project.projectStartDate),
      projectEndDate: new FormControl(this.project.projectEndDate),
      visitDuration: new FormControl({ value: this.project.visitDuration, disabled: false }),
      visitTypes: new FormControl({ value: this.project.visitTypes, disabled: false }),
      projectDesc: new FormControl({ value: this.project.projectDesc, disabled: false }),
      createdBy: new FormControl({ value: this.project.createdBy, disabled: false }),
    });
  }

  selectClient(): void {
    this.testsService.getSelectedClientTests(this._projectForm.get('clientId').value).subscribe(
      result => this.tests = result.tests,
      error => console.log(error)
    );
  }

  onSubmit() {
    this.project = this._projectForm.value;
    this.project.tests = this.testsComponent.tests.value;
    this.project.createdBy = this._localStorage.retrieve('profile').displayName;
    //alert(this.project.clientId +''+this.project.memberTypes);
    this.projectService.addProjectRequests(this.project)
      .subscribe(data => {
        console.log(data)
        this.dialogRef.close(this._projectForm.value);
        if(data.successFlag){
          this._notificationService.success('Project added successfully');
        }else{
          if(data.errorCode == 'EXISTING_PROJECT_EXCEPTION'){
          this._notificationService.error(data.errorMsg);
          }else{
            this._notificationService.error('Creating project Failed');
          }
        }
      }, error => console.log(error));
  }

  dateChanged({ value }){
    if (value) {
      this.minEndDate = value;
    }
  }

  getClients() {
    this.projectService.getAllClientsNames()
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this.clients = result.clients;
      }, error => console.log(error));
  }
}
